export const RIBBONS_GRID_GAP_PX = 14;
export const RIBBONS_MIN_CELL_WIDTH_PX = 108;
export const RIBBONS_MIN_COLUMNS = 1;
export const RIBBONS_MAX_COLUMNS = 4;
export const RIBBONS_WIDTH_STEP_RATIO = 0.22;

/** Fallback reference when no grid context is available (roster file view). */
export function computeRibbonsReferenceWidth(
  maxColumns = RIBBONS_MAX_COLUMNS,
  minCellWidth = RIBBONS_MIN_CELL_WIDTH_PX,
  gap = RIBBONS_GRID_GAP_PX
) {
  return maxColumns * minCellWidth + (maxColumns - 1) * gap;
}

/**
 * Derive ribbon column count (1–4) from card width.
 * One column per 25% of the dashboard grid width (3 grid cols out of 12).
 */
export function computeRibbonsColumnsPerRow(
  containerWidth,
  {
    referenceWidth,
    minColumns = RIBBONS_MIN_COLUMNS,
    maxColumns = RIBBONS_MAX_COLUMNS,
    widthStepRatio = RIBBONS_WIDTH_STEP_RATIO,
    minCellWidth = RIBBONS_MIN_CELL_WIDTH_PX,
    gap = RIBBONS_GRID_GAP_PX,
  } = {}
) {
  const width = Number(containerWidth);
  if (!Number.isFinite(width) || width <= 0) return maxColumns;

  const ref = Number(referenceWidth) > 0
    ? Number(referenceWidth)
    : computeRibbonsReferenceWidth(maxColumns, minCellWidth, gap);

  const ratio = width / ref;
  const columns = Math.ceil(ratio / widthStepRatio);

  return Math.min(maxColumns, Math.max(minColumns, columns));
}
